export enum StoreLoacationEnum {
    //Main Road
    Roadside = 1,
    //Mall
    ShoppingMall = 2,
    //Market
    Market = 3,
    //Stall
    Stall = 4,
    //Warehouse
    Warehouse = 5,
    //Office Building
    OfficeBuilding = 6,
    //Gas Station
    GasStation = 7
}
